import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
interface ICard {
  children: JSX.Element;
  title?: string;
  actionTool?: JSX.Element;
  onClick?: any;
}

const Card: React.FC<ICard> = ({ children, title, actionTool, onClick }) => {
  return (
    <div
      className={tw`w-full bg-white p-2 rounded-md mb-4 -mt-2`}
      style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
    >
      <div>
        <div
          className={tw`uppercase text-primary font-semibold cursor-pointer`}
          onClick={onClick}
        >
          {title}
        </div>
        <div>{actionTool}</div>
      </div>
      {children}
    </div>
  );
};

export default Card;
